import React from 'react'
import './USP.css'
import CommonBanner from '../../components/CommonBanner/CommonBanner'
import USPSection2 from '../../components/USPSection2/USPSection2'

export default function USP() {
  return (
    <>
      {/* Banner section with text "Our Unique Selling Point" */}
      <CommonBanner bannerText="Our Unique Selling Point" />
      {/* Decorative honeycomb section */}
      <div className="honeycomb"></div>

      {/* Section containing details about unique selling points */}
      <USPSection2 />
    </>
  );
}

